import { useMobile } from "lib/@components/mobile"
import { NotInSelector } from "routes/schedule/my-schedules/my-custom-schedules/select-schedule"
import { Box } from "@mui/material"
import { Summaries } from "routes/schedule/plugins/welcome/summaries"
import { SearchBox } from "routes/schedule/plugins/welcome/search-box"

export function Welcome() {
    const isMobile = useMobile()
    const padding = isMobile ? 2 : 8
    return (
        <NotInSelector>
            <Box mb={3} pl={padding} pr={padding} data-cy="welcome">
                <Box maxWidth={800} mx="auto">
                    <Summaries />
                    <SearchBox />
                </Box>
            </Box>
        </NotInSelector>
    )
}
